import styled from 'styled-components';

import { Button } from '@catalyze/ui';

export const Spacer = styled.div`
    flex-grow: 1;
`;

export const StyledButton = styled(Button)`
    width: 100%;
`;
